<script setup>
import {onMounted, ref} from 'vue'
import { useRoute } from 'vue-router';
import { formatNumber } from '@/libs/functions';
import api from '@/libs/api.js';
const invoice = ref({})
const show = ref(false)
const id = ref(0)
const route = useRoute()
const BASE_URL = ref('https://erpaninvest.toeicmax.com')
onMounted(() => {
    id.value = route.query.order_code ? route.query.order_code : route.params.id
    if(id.value > 0){
       getDetail()
    }
   
})
const getDetail = () => {
    api.get("/invoice/"+id.value+"/view").then((response) => {
        invoice.value = response.data.data
        if(invoice.value){
            getUser()
        }
        show.value = true
    });
}
const userCF = ref({}) 
const getUser = async () => {
     await api.get("/settings/find-by-user",{
            params:{
                id : invoice.value.owner_id
            }
        }).then((res) => {
            userCF.value = res.data.data; // data trả về từ server
        })
   
}
</script>
<template>
        <div v-if="show" class=" z-50  left-0 right-0 m-auto not-italic font-medium text-[#43475C] w-full top-0 overflow-y-scroll h-full  fixed left-0 right-0">
            <div class="w-full h-full">
                <div class="w-full bg-white rounded-md h-full">
                    <div class="w-full p-2 ">
                        <div class="flex items-center justify-between">
                            <div class="text-white bg-main rounded w-max px-4 py-2 mb-4">
                                <a :href="invoice.template.doc_path.charAt(0) === '/' ? invoice.template.doc_path : '/'.invoice.template.doc_path">Tải hoá đơn</a>
                            </div>
                            <div class="text-white bg-blue-500 rounded w-max px-4 py-2 mb-4">
                                <a href="/">Trang chủ</a>
                            </div>
                        </div>

        <div class="w-full h-full bg-white" >
            <!-- <PDF :src="BASE_URL+data.template.pdf_path" /> -->
           <div class="grid grid-cols-2 gap-2 text-xs px-4 pt-4">
                <div ><img class="w-14 h-14 object-cover" v-if="userCF && userCF.brand_logo_arr" :src="BASE_URL+userCF?.brand_logo_arr[0]?.thumb" alt=""></div>
                <div class="text-right"><span class="font-semibold">HÓA ĐƠN/PAYMENT REQUEST</span></div>
                <div>Căn hộ: <span class="font-semibold">{{invoice.project.name}}</span></div>
                <div class="text-right">Số/No: <span class="font-semibold">{{invoice.identifier}}</span></div>
                <div>Phòng: <span class="font-semibold">{{invoice.room.name}}</span></div>
                <div class="text-right">Ngày: <span class="font-semibold">{{invoice.issue_date}}</span></div>
                <div>Địa chỉ: <span class="font-semibold">{{invoice.project.address}}</span></div>
                <div class="text-right">Hạn TT: <span class="font-semibold">{{invoice.due_date}}</span></div>
                <div>Khách hàng: <span class="font-semibold">{{invoice.contract.name}}</span></div>
            </div>
            <div class="text-xs mt-4 px-1 border border-gray-200">
               <div class="flex w-full border-y border-gray-200 py-2 text-center font-semibold" >
                   <div class="w-[10%]">STT</div>
                   <div class="w-[30%]">Nội dung</div>
                   <div class="w-[20%]">Đơn giá</div>
                   <div class="w-[10%]">SL</div>
                   <div class="w-[10%]">HS</div>
                   <div class="w-[20%]">TT</div>
               </div>
                <div class="w-full ">
                    <div class="flex w-full border-b border-gray-200 text-center" v-for="(item,key) in invoice.items" :key="key">
                        <div class="w-[10%]  py-2">{{key+1}}</div>
                        <div class="w-[30%]  py-2">{{item.name}}
                            <div class="text-[10px]" v-if="item.service.type == 1">
                                ({{item.start_date}} <br> {{item.end_date}})
                            </div>
                            <div class="text-[10px]" v-if="item.service.type_price == 1 || item.service.type_price == 2">
                                ({{item.meter_log.name}})
                            </div>
                        </div>
                        <div class="w-[20%]  py-2">{{ formatNumber(item.price)}}</div>
                        <div class="w-[10%]  py-2">{{item.quantity.toFixed(2)}}</div>
                        <div class="w-[10%]  py-2">{{item.coefficient.toFixed(2)}}</div>
                        <div class="w-[20%] text-right py-2 font-semibold">{{ formatNumber(item.total) }}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200  py-2 pr-2">Tạm tính:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(invoice.sub_total)}}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200 pr-2 py-2">Giảm giá:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(invoice.promotion)}}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200 pr-2 py-2">Thuế:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(invoice.tax)}}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200 pr-2 py-2">Nợ cũ:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(invoice.total_debt)}}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200 pr-2 py-2">Tổng cộng:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(invoice.total)}}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200 pr-2 py-2">Đã thanh toán:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(invoice.paid)}}</div>
                    </div>
                    <div class="flex w-full border-b border-gray-200 ">
                        <div class="w-[30%]  py-2"></div>
                        <div class="w-[40%] text-right border-r border-gray-200 pr-2 py-2">Phải thanh toán:</div>
                        <div class="w-[40%] text-right py-2 font-semibold">{{ formatNumber(invoice.total_debt)}}</div>
                    </div>
                </div>
                <div v-if="invoice.template.link_qr" class="flex items-center justify-center w-full h-[300px] my-2">
                    <img :src="invoice.template.images" alt="" class="w-full h-full object-contain">
                </div>

                <div class="h-10 w-full flex items-center justify-center">Quét mã thanh toán ở trên! Xin cảm ơn.</div>
                  <div class="text-center pb-2"><a class="text-blue-500 font-semibold" href="/login">Đăng nhập</a> để sử dụng các tính năng khác của chúng tôi! </div>

            </div>
        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
